import { createSelector } from 'reselect'
import { get } from 'lodash'

import key from './types'
import { initialState } from './reducer'

const selectActivityLog = state => get(state, key, initialState)

const selectLoading = createSelector(
  selectActivityLog, state => get(state, 'loading', null)
)

const selectLoadingActivityLog = createSelector(
  selectActivityLog, state => get(state, 'activityLogLoading', null)
)

const selectSuccess = createSelector(
  selectActivityLog, state => get(state, 'activityLogList', [])
)

const selectColumns = createSelector(
  selectActivityLog, state => get(state, 'columns', [])
)

const selectPages = createSelector(
  selectActivityLog, state => get(state, 'pages', null)
)

const selectTotalItems = createSelector(
  selectActivityLog, state => get(state, 'totalItems', 0)
)

const selectDescriptionTypes = createSelector(
  selectActivityLog, state => get(state, 'descriptionTypes', null)
)

const selectEntitiesNames = createSelector(
  selectActivityLog, state => get(state, 'entitiesNames', null)
)

const selectError = createSelector(
  selectActivityLog, state => get(state, 'error', null)
)

const selectDataFilters = createSelector(
  selectActivityLog, state => get(state, 'dataFilters', [])
)

const selectDataFiltersError = createSelector(
  selectActivityLog, state => get(state, 'dataFiltersError', null)
)

export default {
  SUCCESS: selectSuccess,
  COLUMNS: selectColumns,
  ERROR: selectError,
  LOADING: selectLoading,
  LOADING_LIST: selectLoadingActivityLog,
  PAGES: selectPages,
  TOTAL_ITEMS: selectTotalItems,

  DESCRIPTION_TYPES: selectDescriptionTypes,
  ENTITIES_NAMES: selectEntitiesNames,

  FILTER_OBJECT: selectDataFilters,
  ERROR_FILTER_OBJECT: selectDataFiltersError
}
